import React from 'react';
import {BaseMixin, ElementaryMixin, ColorSchemaMixin, ContentMixin, NestingLevelMixin} from '../common/common.js';
import './badge.less'

export const Badge = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    NestingLevelMixin,
    ColorSchemaMixin,
    ContentMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Badge',
    nestingLevel: 'inline',
    classNames: {
      main: 'uu5-bricks-badge badge'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      this.getNestingLevel()
        ? (
          <span {...this.buildMainAttrs()}>
            {this.getChildren()}
            {this.getDisabledCover()}
          </span>
        ) : null
    );
  }
  //@@viewOff:render
});

export default Badge;



// WEBPACK FOOTER //
// ./bricks/badge.js